var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.columnClasses },
    [
      _vm.document
        ? _c("RichTextRenderer", {
            attrs: {
              document: _vm.document,
              "node-renderers": _vm.renderNodes(),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }